import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useGroupData } from '../../hooks/useGroups';
import FamilyChain from '../../components/ui/FamilyChain';
import Modal from '../../components/ui/Modal';
import { initials, fmtDate } from '../../lib/constants';

export default function GroupMembers() {
  const { profile } = useAuth();
  const { group, members, loading } = useGroupData(profile?.group_id);
  const [search, setSearch] = useState('');
  const [viewM,  setViewM]  = useState(null);

  const filtered = members.filter(m => {
    if (!search) return true;
    const s = search.toLowerCase();
    return `${m.first_name} ${m.last_name} ${m.phone} ${m.email}`.toLowerCase().includes(s);
  });

  if (loading) return <div style={{ textAlign: 'center', padding: 40, color: 'var(--text3)' }}>Loading…</div>;

  return (
    <div>
      <div className="flex-between mb-4">
        <div>
          <h1 style={{ fontSize: 20, fontWeight: 800 }}>👥 {group?.name} Members</h1>
          <div style={{ fontSize: 13, color: 'var(--text3)', marginTop: 2 }}>{members.length} active members</div>
        </div>
      </div>

      <div className="card mb-4">
        <div className="card-pad">
          <div className="search-bar">
            🔍 <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Search by name or phone…" />
          </div>
        </div>
      </div>

      <div className="table-wrap">
        <table>
          <thead>
            <tr><th>Name</th><th>District</th><th>Family</th><th>Role in Group</th><th>Membership</th><th>Phone</th><th>Actions</th></tr>
          </thead>
          <tbody>
            {filtered.length === 0 && (
              <tr><td colSpan={7} style={{ textAlign: 'center', padding: 28, color: 'var(--text3)' }}>No members found</td></tr>
            )}
            {filtered.map(m => (
              <tr key={m.id} className={m.status === 'deceased' ? 'row-deceased' : ''}>
                <td>
                  <div className="flex-center gap-2">
                    <div style={{ width: 30, height: 30, borderRadius: '50%', background: 'var(--blue-light)', color: 'var(--blue-dark)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, fontWeight: 700 }}>
                      {initials(m)}
                    </div>
                    <div>
                      <div style={{ fontWeight: 700 }}>{m.first_name} {m.last_name}</div>
                      <div style={{ fontSize: 11, color: 'var(--text3)' }}>{m.email || ''}</div>
                    </div>
                  </div>
                </td>
                <td><span style={{ fontSize: 11, padding: '2px 8px', background: '#EDE7F6', color: '#4527A0', borderRadius: 100, fontWeight: 600 }}>{m.districts?.name || '—'}</span></td>
                <td>{m.families?.name ? <span style={{ fontSize: 11, padding: '2px 8px', background: 'var(--blue-light)', color: 'var(--blue-dark)', borderRadius: 100, fontWeight: 600 }}>🏠 {m.families.name}</span> : '—'}</td>
                <td><span className={`badge ${m.group_role === 'leader' ? 'badge-red' : 'badge-gray'}`}>{m.group_role}</span></td>
                <td><span className={`badge ${m.membership_type === 'Full Member' ? 'badge-blue' : 'badge-gray'}`}>{m.membership_type}</span></td>
                <td style={{ fontSize: 12 }}>{m.phone || '—'}</td>
                <td><button className="btn btn-sm btn-blue" onClick={() => setViewM(m)}>View</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {viewM && (
        <Modal title={`${viewM.first_name} ${viewM.last_name}`} onClose={() => setViewM(null)}
          footer={<button className="btn btn-ghost" onClick={() => setViewM(null)}>Close</button>}>
          <div className="grid-2 mb-4">
            {[['District', viewM.districts?.name || '—'], ['Phone', viewM.phone || '—'], ['Membership', viewM.membership_type], ['Role in Group', viewM.group_role], ['Status', viewM.status]].map(([l, v]) => (
              <div key={l}><div style={{ fontSize: 11, fontWeight: 700, color: 'var(--text3)', textTransform: 'uppercase', marginBottom: 3 }}>{l}</div><div style={{ fontWeight: 600 }}>{v}</div></div>
            ))}
          </div>
          {viewM.family_id && <FamilyChain familyId={viewM.family_id} familyName={viewM.families?.name} currentMemberId={viewM.id} />}
        </Modal>
      )}
    </div>
  );
}
